export default "__VITE_ASSET__1NHNQS14__"